
import { convertObjectToArray, i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { stage_categories as stage_categories, stage_promotion_types as stage_promotion_types, with_score, isMultiStage } from '../../data/bootstrap_stages';

export const operators = {
	date: [
		{ k:'<', v:"Before" },
		{ k:'>', v:"After" },
		{ k:'=', v:"At" },
	],

	list : [
		{k:'=',v:"Equal to"},
		{k:'<>',v:"Different from"},
		//{k:'REGEX',v:"Regular expression"}
	],

	list_expresion : [
		{k:'=',v:"Equal to"},
		{k:'<>',v:"Different from"},
		{k:'like', v:"Contains" },
	],


	belong : [
		{k:'=',v:"Belongs to"},
		{k:'<>',v:"Doesn't belong to"},
	],

	text: [
		{ k:'like', v:"Contains" },
		{ k:'=', v:"Equal to" },
		{ k:'^', v:"Starts with" },
		{ k:'REGEX', v:"Regular expression" },
	],

	simpleText: [
		{ k:'like', v:"Contains" },
		{ k:'REGEX', v:"Regular expression" },
	],

	numeric: [
		{ k:'<', v:"Less than" },
		{ k:'<=', v:"Equal to or less than" },
		{ k:'=', v:"Equal to" },
		{ k:'>=', v:"Equal to or greater than" },
		{ k:'>', v:"Greater than" },
		{ k:'<>', v:"Different from" },
		//{ k:'REGEX', v:"Regular expression" },
	],
	numeric_each: [
		{ k:'<', v:"Less than" },
		{ k:'>', v:"Greater than" },
		{ k:'=', v:"Equal to" },
		{ k:'every', v:"Every" },
		//{ k:'REGEX', v:"Regular expression" },
	],
}
export const email_types = {
	MANUAL:1,
	REGISTER:12,
	ACCEPT:7,
	REJECT:8,
	PARTICIPATE:15,
	NEW_SCHEDULED:13,
	RANKING_LOSE:14,
	ON_REDEEM:16,
	WIN_PRIZE:17,
	ON_TRANSACTION:18,
	REJECT_PRIZE:19,
};

const global_vars = (email,promotion,stages,prizes) => {

	let has_score = false;
	let has_quiz = false;
	//let has_requirements = false;
	//let has_votes = false;
	let has_media_content = false;
	let has_simple_galleries = false;
	let has_prizes = false;
	let has_redeemable_prizes = false;
	let has_stamps_card = false;
	let has_forms = false;

	if(email.stage_id && email.stage_id != "0"){//Stage Selected
		let stage_from_email = stages.find((st) => st.Stage.id == email.stage_id);
		has_simple_galleries = stage_from_email != undefined && (stage_from_email.Stage?.voting_enabled ?? false) && stage_from_email.Stage.type == stage_categories.ID_VOTING_CATEGORY.id && (stage_from_email.Stage?.voting_type ?? 'simple') == 'simple';
		has_media_content = stage_from_email != undefined && [stage_categories.ID_MEDIA_CATEGORY.id,stage_categories.ID_PHOTO_FUN.id].map(String).includes(String(stage_from_email.Stage.type)) ;
		has_quiz = stage_from_email != undefined && stage_from_email.Stage.type == stage_categories.ID_QUIZ_CATEGORY.id
		if(stage_from_email != undefined && with_score(stage_from_email.Stage.promotion_type_id)) has_score = true;
		has_stamps_card = stage_from_email != undefined && stage_from_email.Stage.type == stage_categories.ID_STAMPSCARD_CATEGORY.id
		has_forms = stage_from_email != undefined && stage_from_email.Stage.type == stage_categories.ID_STAGE_FORM.id
	}else{//NO Stage Selected (ALL)
		stages.map((stage) => {
			//if(stage.Stage.reqs_type != undefined && stage.Stage.reqs_code_type == 1 && stage.Stage.reqs_graphic_info != undefined) has_requirements = true;
			//if(stage.Stage.reqs_type != undefined && stage.Stage.reqs_type != '0') has_requirements = true;
			//if(stage.Stage.type == 8) has_votes = true;
			if(stage.Stage.type == stage_categories.ID_QUIZ_CATEGORY.id)has_quiz= true;
			if([stage_categories.ID_MEDIA_CATEGORY.id,stage_categories.ID_PHOTO_FUN.id].map(String).includes(String(stage.Stage.type)))has_media_content = true;
			if(stage.Stage.type == stage_categories.ID_VOTING_CATEGORY.id && (stage.Stage?.voting_enabled ?? false) && (stage.Stage?.voting_type ?? 'simple') == 'simple')has_simple_galleries = true;
			if(with_score(stage.Stage.promotion_type_id)) has_score = true;
			if(stage.Stage.type == stage_categories.ID_STAMPSCARD_CATEGORY.id)has_stamps_card= true;
			if(stage.Stage.type == stage_categories.ID_STAGE_FORM.id)has_forms= true;
		});
	}
	has_score == promotion.has_ranking && promotion.public_entries ? has_score : false;
	has_prizes = prizes.length>0;
	has_redeemable_prizes = prizes.filter((p)=> {return (p?.PrizeType?.redeemable ?? false) == true}).length > 0;

	return [has_quiz, has_media_content, has_prizes, has_score, has_redeemable_prizes, has_stamps_card, has_simple_galleries, has_forms];
}

export const conditions = (intl, promotion, cfs, stages, prizes, email, languages, segments) => {
	let conditions = [];
	const type = email.type;
	const stage_id = email.stage_id && email.stage_id > 0 ? email.stage_id : false;

	const [has_quiz, has_media_content, has_prizes, has_score, has_redeemable_prizes, has_stamps_card, has_simple_galleries, has_forms] = global_vars(email,promotion,stages,prizes);

	//Prizes
	let condition_prizes = [];

	const _show_prizes = ((type == email_types.ON_REDEEM && has_redeemable_prizes || has_prizes && type != email_types.ON_REDEEM) && type != email_types.ON_TRANSACTION) ? true : false;
	if(_show_prizes){
		let prizes_arr = [];
	   // prizes_arr.push({k:'all',v:'Has won a prize'});
		prizes.map((p,index) => {
			if(type == email_types.ON_REDEEM && p.PrizeType.redeemable || type != email_types.ON_REDEEM){
				prizes_arr.push({k:p.PrizeType.id,v:p.PrizeType.title  + (p.PrizeType.reference != undefined ? ' ('+p.PrizeType.reference+')' : '')});
			}
		});
		//prizes_arr.push({k:'none',v:'Has not won any prize'});
		if(type != email_types.WIN_PRIZE && type != email_types.REJECT_PRIZE){
			condition_prizes.push({
				key:'prize_winners',
				name:"Has won a specific prize",
				group:['user'],
				tier1:'Prizes.*.Prize.prize_type',
				getOptions:(current,level) => {
					if(level == 0) {
						return {
							type:'multiple',
							allowMatchAll:true,
							key:'value',
							options:prizes_arr
						};
					}
					return null;
				},
				humanize:(current) => {
					let prize_arr = [];
					if(typeof current.value == 'object'){
						(current.value).map((v,i) =>{
							const find = prizes_arr.find((p) => p.k == v);
							if(find)prize_arr.push(find.v);
						});
					}
					return intl.formatMessage({id:'Won {list}'},{list:prize_arr.join(" " + intl.formatMessage({id:'or'}) + " ")});
				},
			});


			condition_prizes.push({
				key:'prize_winners_any',
				name:"Has won a prize",
				group:['user'],
				type:'matchAny',
				noValue:true,
				tier1:'Prizes.*',
				humanize:(current)=>{
					return intl.formatMessage({id:'Has won a prize'});
				},
				getOptions:(current,level) => {
					if(level == 0) {
						return { type:'no_actions', key:'value', options:['not_empty'] };
					}
					return null;
				}
			});
		
			
			if(type != email_types.ON_REDEEM){
				condition_prizes.push({
					key:'prize_winners_no',
					name:"Has not won any prize",
					group:['user'],
					noValue:true,
					type:'matchNone',
					tier1:'Prizes.*',
					humanize:(current)=>{
						return intl.formatMessage({id:'Has not won any prize'});
					},
					getOptions:(current,level) => {
						if(level == 0) {
							return {
								type:'no_actions',
								key:'value',
								options:['empty']
							};
						}
						return null;
					}
				});
			}
		}	

		if(type == email_types.WIN_PRIZE || type == email_types.REJECT_PRIZE ){

			let prize_assignation_manual = (prizes.filter(p => {return p.PrizeType.assignation == 1}).length > 0) ? true : false;
			let prize_assignation_random = (prizes.filter(p => {return p.PrizeType.assignation == 2}).length > 0) ? true : false;
			let prize_assignation_participate = (prizes.filter(p => {return p.PrizeType.assignation == 3}).length > 0) ? true : false;
			let prize_assignation_iw = (prizes.filter(p => {return p.PrizeType.assignation == 4}).length > 0) ? true : false;
			let prize_assignation_probability = (prizes.filter(p => {return p.PrizeType.assignation == 5}).length > 0) ? true : false;
			let prize_assignation_coins = (prizes.filter(p => {return p.PrizeType.assignation == 6}).length > 0) ? true : false;

			let prize_assignation = [];
			if(prize_assignation_manual)prize_assignation.push({k:1,v:'By Manual Assignment'});
			if(prize_assignation_random)prize_assignation.push({k:2,v:'By Random Draw'});

			if(prize_assignation_participate || prize_assignation_iw || prize_assignation_probability){
				prize_assignation.push({k:'direct',v:'Direct Prizes'});
			}

			//if(prize_assignation_participate)prize_assignation.push({k:3,v:'On Participating'});
			//if(prize_assignation_iw)prize_assignation.push({k:4,v:'By Instant Win'});
			//if(prize_assignation_probability)prize_assignation.push({k:5,v:'By probability'});
			if(prize_assignation_coins)prize_assignation.push({k:6,v:'By virtual coins'});

			const cond_key = (type == email_types.WIN_PRIZE) ? 'prize_assignation' : 'prize_rejection';
			const cond_label = (type == email_types.WIN_PRIZE) ? 'Has won a prize' : 'Has lost a prize';

			condition_prizes.push({
				key:cond_key,
				skip_reapeated_key:true,
				name:cond_label,
				group:['user'],
				tier1:'Prizes.*.Prize.prize_type',
				getOptions:(current,level) => {
					if(level == 0) {
						return {
							//key:'value',
							//type:'multiple',
							options:prize_assignation
						}
					}

					let assignation_types = [parseInt(current.options[0].k)];
					if(current.options[0].k == 'direct')assignation_types = [3,4,5];//Premis directes, On Participating + By Instant Win + By probability

					const _prizes =  prizes.filter(p => {return assignation_types.includes(parseInt(p.PrizeType.assignation))});

					if(level == 1/* && _prizes.length > 1*/){
						return {
							key:'value',
							options:[{k:`assignation_${current.options[0].k}`,v:"***All"},{k:'specific',v:"Specific prize"},]
						};
					}else if(level == 1 || (level == 2 && current.options[1].k == 'specific')){
						const _options = prizes_arr.filter((item)=> _prizes.map(item2 =>item2.PrizeType.id).includes(item.k));
						return {
							key:'value',
							type:'multiple',
							options:_options
						};
					}
				},
				humanize:(current) => {
					let assign_arr = [];
					if(typeof current.value == 'object'){
						(current.value).map((v,i) =>{
							const find = prizes_arr.find((p) => p.k == v);
							if(find)assign_arr.push(find.v);
						});
						return intl.formatMessage({id:(type == email_types.WIN_PRIZE) ? 'Won {list}' : 'Lost {list}'},{list:assign_arr.join(" " + intl.formatMessage({id:'or'}) + " ")});
					}else if((current.value).startsWith('assignation_')){
						const assignation = (current.value).replace('assignation_','');
						const find = prize_assignation.find((p) => p.k == assignation);
						if(find){
							return `${intl.formatMessage({id:cond_label})} "${intl.formatMessage({id:find.v})}"`;
						}
					}
				},
			});

			if(type == email_types.REJECT_PRIZE){
				
				condition_prizes.push({
					key:'prize_type_rejection',
					name:intl.formatMessage({ id:"Rejection Type" }),
					group:['user'],
					tier1:'Prizes.*.Prize.rejection_type',
					humanize:(current) => {
						let returned_msg = "";
						switch(parseInt(current.value)) {
		
							case 1:
								returned_msg = "Voluntary rejection";
								break;
							case 2:
								returned_msg = "Claiming period expired";
								break;
							case 3:
								returned_msg = "Administrator manually revokes";
								break;
						}
						return intl.formatMessage({id:'Rejection Type {status}'},{status:`: ${intl.formatMessage({id:returned_msg})}`})
					},
					getOptions:(current, level) => {
						if(level == 0) {
							return {
								key:'value',
								options:[
									{ k:1, v:"Voluntary rejection" },
									{ k:2, v:"Claiming period expired" },
									{ k:3, v:"Administrator manually revokes" },
								],
							};
						}
						return null;
					}
				});
			}
		}
		
	}
	
	//Public Entry
	let status_entry = [];
	status_entry.push({id:0,value:'Pending'});
	status_entry.push({id:4,value:'No'});
	status_entry.push({id:1,value:'Yes'});

	//conditions.push({group:['user'],condition:'all',name:'All participations'});
	conditions.push({
		key:'language',
		name:intl.formatMessage({ id:"Language" }),
		group:['user'],
		tier1:'User.keyword',
		getOptions:(current, level) => {
			if(level == 0) {
				let ops = promotion.languages;
				return {
					key:'value',
					type:'multiple',
					options:ops.map((k) => ({ k:k.id, v: k.value}))
				};
			}
			return null;
		},
		humanize:(current) => {
			let languages_list = [];
			if(typeof current.value == 'object'){
				current.value.map((lang, l) => {
					languages_list.push(`${languages[lang]}`);
				});
			}else{
				languages_list.push(`${current.value}`)
			}
		   return intl.formatMessage({id:'Speaks {list}'},{list:languages_list.join(" " + intl.formatMessage({id:'or'}) + " ")})
		},
	});

	if(type != email_types.ACCEPT && type != email_types.REJECT && type != email_types.RANKING_LOSE && type != email_types.ON_REDEEM && type != email_types.WIN_PRIZE && type != email_types.ON_TRANSACTION){
		conditions.push({
			key:'created',
			name:intl.formatMessage({ id:(type == email_types.PARTICIPATE) ? "Participation date" : "Registration date" }),
			group:['user'],
			type:'date',
			tier1:'User.created',
			getOptions:(current, level) => {
				if(level == 0) {
					return {
						key:'operator',
						options:[...operators.date]
					};
				}
				if(level == 1) {
					return {
						type:'date',
						label:"Choose a date",
						options:[],
						field_options:{show_time:false}
					};
				}
			},
			humanize:(current) => {
				const label =  email_types.PARTICIPATE ? 'Participation date {operator} {day}' : 'Registration date {operator} {day}';
				const op = operators.date.find((o) => o.k == current.operator);
				return intl.formatMessage({id:label},{day:EPDateFormat(current.value, 'LL'),operator:op.v})
			},
		});
	}

	if(type == email_types.REGISTER || type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE){

		const custom_fields = convertObjectToArray(cfs);

		if(custom_fields.filter((c) => c.type!=7).length > 0) {
			conditions.push({
				key:'custom_fields',
				group:['user'],
				name:intl.formatMessage({ id:"Custom fields" }),
				tier1:'CustomValue.{field_id}',
				template:"Custom Field {field}",
				getOptions:(current, level) => {
					if(level == 0) {
						return {
							options:custom_fields.map((cf) => {
								let title = cf?.title ?? "No title";
								return ({ k:cf.id, v:((title.length > 40) ? title.substr(0, 40).trim() + "..." : title) })
							}
							)
						}
					}

					if(level == 1) {
						let cf = custom_fields.find((cfield) => cfield.id == current.options[0].k);

						switch(cf.type) {
							case '1':
								return {
									key:'value',
									type:'input',
								};
							case '3':
								return {
									key:'value',
									type:'multiple',
									options:[
										{ k:0, v:"Unselected" },
										{ k:"1", v:"Checked" },
									],
								};
							case '2':
							case '4':
							case '5':
								return {
									key:'value',
									type:'multiple',
									options:cf.options.split("\n").map((option) => ({ k:option, v:option })),
								};
							case '6':
								return { key:'operator',forcetype:'date', options:[...arrayOperators.dateOperators],
								field_options:{show_time:false} };
						}

						return {
							key:'value',
							type:'input',
						};
					}

					if(level == 2) {
						let cf = custom_fields.find((cfield) => cfield.id == current.options[0].k);

						switch(cf.type) {
							case '6':
								return { type:'date', label:"Choose specific date", options:[],
								field_options:{show_time:false} };
						}
						return null;
					}

					return null;
				},
				getValue:(current) => {
					let data = {};
					data.field = current.options[0];
					return data;
				}
			});
		}
	}

	if(has_prizes &&
		(type != email_types.REGISTER || promotion.login_type == 4) && //Register + Guest Mode
		type != email_types.RANKING_LOSE &&
		type != email_types.ACCEPT
		&& type != email_types.REJECT){
		conditions = [...conditions,...condition_prizes];
	}

	if(type == email_types.PARTICIPATE || type == email_types.RANKING_LOSE){

		if(type == email_types.PARTICIPATE){
			conditions.push({
				key:'participations',
				name:intl.formatMessage({ id:"Number of participations in the stage" }),
				group:['user'],
				type:'numeric',
				tier1:'User.participations',
				getOptions:(current, level) => {
					if(level == 0) {
						let ops = current.filter.tier2;
						return { key:'operator', options:[...operators.numeric_each]};
					}
					if(level == 1) {
						return {
									key:'value',
									type:'input',
									field_options:{_type:'number'}
								}
					}
					return null;
				}
			});

			conditions.push({
				key:'total_participations',
				name:intl.formatMessage({ id:"Total number of participations in the promotion" }),
				group:['user'],
				type:'numeric',
				tier1:'User.total_participations',
				getOptions:(current, level) => {
					if(level == 0) {
						let ops = current.filter.tier2;
						return { key:'operator', options:[...operators.numeric_each]};
					}
					if(level == 1) {
						return {
							key:'value',
							type:'input',
							field_options:{_type:'number'},
							extra:intl.formatMessage({id:"It is the total of all the participations of the user in the entire promotion, counting all the participation stages."})
						}
					}
					return null;
				}
			});

		}
		if(has_score && (stage_id || !isMultiStage(promotion.promotion_type_id)) ){
			conditions.push({
				key:'participation_score',
				group:['user'],
				name:intl.formatMessage({ id:"Participation score" }),
				tier1:'User.score',
				tier2:{...operators.numeric},
				tier3:'input',
				type:'numeric',
				getOptions:(current, level) => {
					if(level == 0) {
						let ops = current.filter.tier2;
						return { key:'operator', options:[...operators.numeric]};
					}
					if(level == 1) {
						return {
							key:'value',
							type:'input',
							field_options:{_type:'number'},
							extra:intl.formatMessage({id:"Points that the user has obtained in the participation that has been completed."})
						}
					}
					return null;
				}
			});

			if(type == email_types.PARTICIPATE){
				conditions.push({
					key:'best_score',
					name:intl.formatMessage({ id:"Takes the lead in the ranking" }),
					group:['user'],
					noValue:true,
					type:'matchNone',
					tier1:'StageScore.*',
					getOptions:(current,level) => {
						if(level == 0) {
							return {
								type:'no_actions',
								key:'value',
								options:['none'],
								extra:intl.formatMessage({id:"The user obtains the highest score in the ranking so far, and takes the lead."})
							};
						}
						return null;
					},
					humanize:(current) => {
						return intl.formatMessage({id:"Takes the lead in the ranking"});
					},
				})
			}
		}

		if(has_score && type == email_types.PARTICIPATE){
			conditions.push({
				key:'completed_game',
				name:intl.formatMessage({ id:"The participant has completed the game" }),
				group:['user'],
				type:'numeric',
				tier1:'User.completed_game',
				humanize:(current) => {
					let returned_msg = "";
					switch(current.value) {
						case '1':
							returned_msg = "Yes";
							break;
						case '0':
							returned_msg = "No";
							break;
					}
					return intl.formatMessage({ id:"Completed game {status}" },{status:`: ${intl.formatMessage({id:returned_msg})}`})
				},
				getOptions:(current, level) => {
					if(level == 0) {
						return {
							key:'value',
							options:[
								{ k:'1', v:"Yes" },
								{ k:'0', v:"No" },
							],
						};
					}
					return null;
				}
			});
		}

	}

	if(type == email_types.RANKING_LOSE){
		conditions.push({
			key:'ranking_position',
			group:['user'],
			name:intl.formatMessage({ id:"Ranking position" }),
			tier1:'User.ranking_position',
			tier2:{...operators.numeric},
			tier3:'input',
			type:'numeric',
			getOptions:(current, level) => {
				if(level == 0) {
					return {
						key:'value',
						type:'input',
						field_options:{_type:'number',min:1,max:50},
						extra:intl.formatMessage({id:"Enter the position number of the ranking you want to evaluate to send this email."})
					}
				}
				return null;
			},
			humanize:(current) => {
				return intl.formatMessage({id:'Loses position number {position} in the ranking'},{position:current.value})
			},
		});
	}
	
	if(type == email_types.MANUAL || type == email_types.NEW_SCHEDULED || type == email_types.REGISTER || type == email_types.PARTICIPATE){

		if(type == email_types.MANUAL || type == email_types.NEW_SCHEDULED){
			conditions.push({
				key:'public_entry',
				name:intl.formatMessage({ id:"User status" }),
				group:['user'],
				tier1:'User.public_entry',
				humanize:(current) => {
					let returned_msg = "";
					switch(parseInt(current.value)) {
						case 0:
							returned_msg = "Email pending to validate";
							break;
						case 1:
							returned_msg = "Accepted";
							break;
					}
					return intl.formatMessage({id:'User status {status}'},{status:`: ${intl.formatMessage({id:returned_msg})}`})
				},
				getOptions:(current, level) => {
					if(level == 0) {
						return {
							key:'value',
							options:[
								{ k:0, v:"Email pending to validate" },
								{ k:1, v:"Accepted" },
							],
						};
					}
					return null;
				}
			});
			if(promotion.need_email == 1){
				conditions.push({
					key:'email',
					name:intl.formatMessage({ id:"Email" }),
					group:['user'],
					type:'text',
					tier1:'User.email',
					getOptions:(current, level) => {
						if(level == 0) {
							return { key:'operator', options:[...operators.list_expresion]};
						}
						if(level == 1) {
							return {
								key:'value',
								type:'input',
							}
						}
						return null;
					},
					humanize:(current) => {
						let _label = null;
						switch(current.operator){
							case '=': _label = "{condition} is {value}"; break;
							case '<>': _label = "{condition} is not {value}"; break;
							case 'like': _label = "{condition} contains {value}"; break;
						}
						if(_label){
							_label = intl.formatMessage({id:_label},current);
							return _label.charAt(0).toUpperCase() + _label.slice(1)
						}
						return null;
					},
				});
			}

			if(has_simple_galleries){

				const media_galleries = [];
				stages.map((stage) => {
					if(stage.Stage.type == stage_categories.ID_VOTING_CATEGORY.id && (stage.Stage?.voting_enabled ?? false) && (stage.Stage?.voting_type ?? 'simple') == 'simple'){
						media_galleries.push({k:stage.Stage.id,v:stage.Stage?.display_title ?? `${intl.formatMessage({id:"Stage"})} #${stage.Stage.id}`});
					}
				});

				if(media_galleries.length > 0){
					conditions.push({
						key:'has_entry_gallery',
						name:intl.formatMessage({ id:"Has content in a gallery" }),
						group:['user'],
						type:'matchAny',
						noValue:true,
						tier1:'Stages.*',
						getOptions:(current, level) => {
							if(level == 0) {
								return { key:'value', type:'multiple',  options:media_galleries	}
							}
						},
						humanize:(current) => {
							const stages_arr = [];
							if(typeof current.value == 'object'){
								current.value.map((stage, l) => {
									let st = media_galleries.find((c) => c.k == stage);
									stages_arr.push(`${st.v}`);
								});
							}else{
								let st = media_galleries.find((stage) => stage.k == current.value);
								stages_arr.push(`${st.v}`);
							}
							return `${intl.formatMessage({ id:"Has content in a gallery" })}: ${stages_arr.join(` ${intl.formatMessage({ id:"or" })} `)}`;
						},
					})
				}
			}

		}

		conditions.push({
			key:'country',
			name:intl.formatMessage({ id:"Country" }),
			group:['user'],
			tier1:'User.country_id',
			getOptions:(current, level) => {
				if(level == 0) {
					const countries_arr = promotion.countries_arr != undefined ? promotion.countries_arr : [];
					return { key:'value', type:'multiple',  options:countries_arr.map((k) => ({ k:k.id, v: k.value}))};
				}
				return null;
			},
			humanize:(current) => {
				let countries_list = [];
				if(typeof current.value == 'object'){
					current.value.map((country, l) => {
						const countries_arr = promotion.countries_arr != undefined ? promotion.countries_arr : [];
						let c = countries_arr.find((c) => c.id == country);
						countries_list.push(`${c.value}`);
					});
				}else{
					const countries_arr = promotion.countries_arr != undefined ? promotion.countries_arr : [];
					let c = countries_arr.find((c) => c.id == current.value);
					countries_list.push(`${c.value}`);
				}
				return intl.formatMessage({id:'Registered from country: {list}'},{list:countries_list.join(" " + intl.formatMessage({id:'or'}) + " ")})
			},
		});

		if(type == email_types.MANUAL || type == email_types.NEW_SCHEDULED){
			conditions.push({
				key:'invitations',
				name:intl.formatMessage({ id:"Total number of participations" }),
				group:['user'],
				type:'numeric',
				tier1:'User.invitations',
				getOptions:(current, level) => {
					if(level == 0) {
						let ops = current.filter.tier2;
						return { key:'operator', options:[...operators.numeric_each]};
					}
					if(level == 1) {
						return {
							key:'value',
							type:'input',
							field_options:{_type:'number'},
							extra:intl.formatMessage({id:"It is the total of all the participations of the user in the entire promotion, counting all the participation stages."})
						}
					}
					return null;
				}
			});

			/*conditions.push({
				key:'marked',
				name:intl.formatMessage({ id:"Marked" }),
				group:['user'],
				type:'numeric',
				tier1:'User.marked',
				humanize:(current) => {
						let returned_msg = "";
						switch(current.value) {
							case '1':
								returned_msg = "Yes";
								break;
							case '0':
								returned_msg = "No";
								break;
						}
						return intl.formatMessage({id:'Marked {status}'},{status:`: ${intl.formatMessage({id:returned_msg})}`})
					},
					getOptions:(current, level) => {
						if(level == 0) {
							return {
								key:'value',
								options:[
									{ k:'1', v:"Yes" },
									{ k:'0', v:"No" },
								],
							};
						}
						return null;
					}
			});*/
		}
	}

	if(type == email_types.ON_TRANSACTION){
		conditions.push({
			key:'transaction_amount_positive',
			group:['user'],
			name:intl.formatMessage({ id:"By obtaining a certain amount of coins" }),
			tier1:'LoyaltyLogin.amount',
			tier2:{...operators.numeric},
			tier3:'input',
			type:'numeric',
			getOptions:(current, level) => {
				if(level == 0) {
					let ops = current.filter.tier2;
					return { key:'operator', options:[...operators.numeric]};
				}
				if(level == 1) {
					return {
						key:'value',
						type:'input',
						field_options:{_type:'number'},
						extra:intl.formatMessage({id:"Virtual coins that the user has obtained in the transaction."})
					}
				}
				return null;
			}
		});

		conditions.push({
			key:'transaction_amount_negative',
			group:['user'],
			name:intl.formatMessage({ id:"By spending a certain amount of coins" }),
			tier1:'LoyaltyLogin.amount',
			tier2:{...operators.numeric},
			tier3:'input',
			type:'numeric',
			getOptions:(current, level) => {
				if(level == 0) {
					let ops = current.filter.tier2;
					return { key:'operator', options:[...operators.numeric]};
				}
				if(level == 1) {
					return {
						key:'value',
						type:'input',
						field_options:{_type:'number'},
						extra:intl.formatMessage({id:"Virtual coins that the user has obtained in the transaction."})
					}
				}
				return null;
			}
		});
		
		const type_transactions = [
			{ k:1, v:intl.formatMessage({ id:"Earned for participating in a stage" }) },
			{ k:2, v:intl.formatMessage({ id:"Spent to redeem a prize" }) },
			{ k:3, v:intl.formatMessage({ id:"Manual transaction by administrator" }) },
			{ k:4, v:intl.formatMessage({ id:"As prize won" }) },
			{ k:5, v:intl.formatMessage({ id:"Spent to participate in a stage" }) },
			{ k:6, v:intl.formatMessage({ id:"Received via API" }) }
		];

		conditions.push({
			key:'transaction_type',
			group:['user'],
			name:intl.formatMessage({ id:"Transaction type" }),
			tier1:'LoyaltyLogin.type',
			type:'numeric',
			getOptions:(current,level) => {
				if(level == 0) {
					return {
						type:'multiple',
						allowMatchAll:true,
						key:'value',
						options:type_transactions,
					};
				}
				return null;
			},
			humanize:(current) => {
				let type_transactions_arr = [];
				if(typeof current.value == 'object') {
					(current.value).map((v,i) =>{
						const find = type_transactions.find((p) => (p.k == v));

						if(find) {
							type_transactions_arr.push(find.v);
						}
					});
				}

				return intl.formatMessage({
					id:"Transaction of {list}",
				}, {
					list:type_transactions_arr.join(` ${intl.formatMessage({ id:"or" })} `),
				});
			},
		});	

		conditions.push({
			key:'transaction_coin_balance',
			group:['user'],
			name:intl.formatMessage({ id:"Balance" }),
			tier1:'LoyaltyLogin.balance',
			tier2:{...operators.numeric},
			tier3:'input',
			type:'numeric',
			getOptions:(current, level) => {
				if(level == 0) {
					let ops = current.filter.tier2;
					return { key:'operator', options:[...operators.numeric] };
				}
				if(level == 1) {
					return {
						key:'value',
						type:'input',
						field_options:{_type:'number'},
						extra:intl.formatMessage({
							id:"Total coin balance when a transaction is completed.",
						}),
					}
				}
				return null;
			}
		});
	}
	if(type == email_types.MANUAL || type == email_types.NEW_SCHEDULED){
		conditions.push({
			key:'total_coin_balance',
			group:['user'],
			name:intl.formatMessage({ id:"Total balance" }),
			tier1:'LoyaltyTotal.total',
			tier2:{...operators.numeric},
			tier3:'input',
			type:'numeric',
			getOptions:(current, level) => {
				if(level == 0) {
					let ops = current.filter.tier2;
					return { key:'operator', options:[...operators.numeric]};
				}
				if(level == 1) {
					return {
						key:'value',
						type:'input',
						field_options:{_type:'number'},
						extra:intl.formatMessage({
							id:"Total coin balance.",
						}),
					}
				}
				return null;
			}
		});
	}


	if(segments && segments.length>0){
		conditions.push({
			key:'segment',
			name:"Segment",
			group:['user'],
			tier1:'User.segment',
			getOptions:(current, level) => {
				if(level == 0) {
					return {
						key:'operator',
						options:[...operators.belong]
					};
				}
				if(level == 1) {
					let ops = segments;
					return {
						key:'value',
						type:'multiple',
						options:ops.map((k) => ({ k:k.Segment.id, v: k.Segment.title + (k.Segment.ref ? ' (#'+k.Segment.ref+')' : '')}))
					};
				}
				return null;
			},
			humanize:(current) => {
				let segments_list = [];
				if(typeof current.value == 'object') {
					current.value.map((s, l) => {
						let seg = segments.find((seg) => seg.Segment.id == s);
						let segment_name = (seg != undefined) ? (seg.Segment.ref ? `#${seg.Segment.ref}` : seg.Segment.title) : intl.formatMessage("Unknown");
						segments_list.push(`${segment_name}`);
					});
				} else {
					segments_list.push(`${current.value}`)
				}
				const op = operators.belong.find((o) => o.k == current.operator);

				return intl.formatMessage({
					id:"User {operator} segment {list}",
				}, {
					operator:(op.v).toLowerCase(),
					list:segments_list.join(` ${intl.formatMessage({ id:"or"})} `),
				});
			},
		});
	}

	return conditions;
}

export const message_smartags = (intl, promotion, cfs, stages, prizes, email) => {
	const i18n = (m, c) => i18nIntl(m, intl, c);

	const type = email.type;

	const is_notification = email.notification == 1 ? true : false;
	const has_nickname = promotion.need_nickname ? true : false;
	const has_names = !promotion.hide_name;
	const has_virtual_coins = promotion?.loyalty_enabled ?? false;
	const its_autologin = promotion.allow_auto_login || promotion.login_type == "2";

	const more_than_one_stage = stages.length > 1 ? true : false;
	const [has_quiz, has_media_content, has_prizes, has_score, has_redeemable_prize, has_stamps_card, has_simple_galleries, has_forms] = global_vars(email,promotion,stages,prizes);

	let has_prize_codes = false;
	if(has_prizes){
		prizes.map((p,i) => {
		  if(p.PrizeType.type>0)has_prize_codes=true;
		})
	}
	let smartags = [];
	
	if(has_names){
		//if(!has_nickname)smartags.push({tag:'user_full_name',label:'User full name'});
		smartags.push({tag:'user_first_name',label:'User first name'});
		smartags.push({tag:'user_last_name',label:'User last name'});
	}
	if(has_nickname){
		smartags.push({tag:'user_nickname',label:'User nickname'});
	}

	if(type != email_types.ON_REDEEM && type != email_types.ON_TRANSACTION){
		smartags.push({tag:'user_email',label:'User email'});
		if(type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE || type == email_types.REGISTER){//Participate
			smartags.push({tag:'user_source',label:'User source'});
			const custom_fields = convertObjectToArray(cfs);

			custom_fields.sort((a, b) => {
				if (a.pos === null && b.pos === null) {
					return 0; // Ambos son nulos, mantener su orden relativo
				}
				if (a.pos === null) {
					return -1; // `a` va primero si `a.pos` es nulo
				}
				if (b.pos === null) {
					return 1; // `b` va primero si `b.pos` es nulo
				}
				return a.pos - b.pos; // Orden ascendente por `pos`
			});

			if(custom_fields.filter((c) => c.type!=7).length > 0) {
				custom_fields.map((cf) => {
					let title = isNotEmpty(cf,'title',['']) ? cf.title : "No title";
						title = title.length  > 40 ? title.substr(0, 40).trim() + "..." : title;
					const _short_title = isNotEmpty(cf,'short_title',['']) ? cf.short_title : null; 
					smartags.push({tag:'custom_field:'+(_short_title ? _short_title : cf.id),label:`${i18n("Custom fields")}: ${title}`  + (_short_title ? ' ('+cf.short_title+')' : '')});
				});
			}
		}
		smartags.push({tag:'promo_link',label:'Promotion link'});
	}

	if(has_prizes && type == email_types.REJECT_PRIZE){
		smartags.push({tag:'prize_name',label:'Prize Name'});
		smartags.push({tag:'rejection_reason',label:'Prize Rejection reason'});
		return smartags;
	}
	
	if(promotion.has_ranking && promotion.public_entries == "1"){
		smartags.push({tag:'ranking_url',label:'Ranking Url'});
	}
	if(type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE || type == email_types.RANKING_LOSE){//Participate
		if(isMultiStage(promotion.promotion_type_id) && type != email_types.WIN_PRIZE)smartags.push({tag:'stage_name',label:'Stage name'});
		if(has_score){
			smartags.push({tag:'participation_score',label:'Participation score'});
			//if(more_than_one_stage)smartags.push({tag:'total_score',label:'Total Score'});
		}

		if(has_forms && type == email_types.PARTICIPATE){
			smartags.push({tag:'participation_data',label:'Participation data'});
		}

		//si te prizes
		if(has_prizes && (type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE)){
			smartags.push({tag:'prize_name',label:'Prize Name'});
			smartags.push({tag:'prize_summary',label:'Prize Summary'});//si te prizes
			prizes.map((p,i) => {
				if(p.PrizeType.reference != undefined && p.PrizeType.reference != ''){
					smartags.push({hide:true,tag:'prize_summary:'+p.PrizeType.reference,label:`${i18n("Prize Summary")}: ${p.PrizeType.title}`  + (p.PrizeType.reference != undefined ? ' ('+p.PrizeType.reference+')' : '')});
					smartags.push({hide:true,tag:'prize_code:'+p.PrizeType.reference,label:`${i18n("Prize Code")}: ${p.PrizeType.title}`  + (p.PrizeType.reference != undefined ? ' ('+p.PrizeType.reference+')' : '')});
				}
			})
			if(has_prize_codes)smartags.push({tag:'prize_code',label:'Promotional code'});//si te prizes
		}
		if(has_quiz && (type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE))smartags.push({tag:'quiz_summary',label:'Quiz result'});
		
		if(type == email_types.PARTICIPATE && !is_notification){
			if(has_media_content)smartags.push({tag:'entry_gallery_link',label:'Link to entry in a gallery'});
			if(has_simple_galleries){
				smartags.push({tag:'voted_entry_link',label:'Link to voted entry'});
				smartags.push({tag:'voted_entry_name',label:'Name of the voted entry'});
			}
		}

		if(has_media_content && !is_notification && false){
			smartags.push({tag:'user_voteme_url',label:'My entry URL'});
			smartags.push({tag:'share_voteme_url',label:'Buttons to share my entry'});
		}
		if(has_stamps_card && (type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE))smartags.push({tag:'stamp_card_link',label:'Stamp card link'});
	}else if((type == email_types.ACCEPT || type == email_types.REJECT) && !is_notification){//Accept or reject

		if(type == email_types.ACCEPT && has_media_content && !is_notification){
			smartags.push({tag:'entry_gallery_link',label:'Link to entry in a gallery'});
		}

		if(has_media_content && false){
			smartags.push({tag:'user_voteme_url',label:'My entry URL'});
			smartags.push({tag:'share_voteme_url',label:'Buttons to share my entry'});
		}
	}else{//Manual/Scheduled/Register/OnRedeem/OnTransaction
		if(has_prizes && type == email_types.ON_REDEEM){
			smartags.push({tag:'prize_name',label:'Prize Name'});
			smartags.push({tag:'prize_summary',label:'Prize Summary'});
			if(promotion.code_validator)smartags.push({tag:'validation_site',label:'Validation Point name'});
		}else if(has_prizes && promotion.login_type == 4 && type == email_types.REGISTER){//Guest Mode + Register => Maybe Prize
			smartags.push({tag:'prize_name',label:'Prize Name'});
			smartags.push({tag:'prize_summary',label:'Prize Summary'});
			if(has_prize_codes)smartags.push({tag:'prize_code',label:'Promotional code'});//si te prizes
		}else if(has_prizes && type != email_types.REGISTER && type != email_types.ON_TRANSACTION){
			//smartags.push({tag:'prize_name',label:'Prize Name'});
			smartags.push({tag:'prize_summary',label:'Prize Summary'});
		}

		if(type == email_types.NEW_SCHEDULED || type == email_types.MANUAL){
			if(has_media_content && has_simple_galleries){
				smartags.push({tag:'entry_gallery_link',label:'Link to entry in a gallery'});
			}
			if(has_score)smartags.push({tag:'total_score',label:'Total score'});
			if(has_stamps_card)smartags.push({ tag:'stamp_card_link', label:"Stamp card link" });
		}

		if(has_virtual_coins){
			if(type == email_types.ON_TRANSACTION){
				smartags.push({ tag:'transaction_amount', label:"Transaction amount" });
				smartags.push({ tag:'transaction_coin_balance', label:"Coin balance" });
			}else if(type == email_types.NEW_SCHEDULED || type == email_types.MANUAL){
				smartags.push({ tag:'total_coin_balance', label:"Total coin balance" });
			}
		}
	}

	if(its_autologin){
		smartags.push({tag:'external_id',label:'External ID'});
	}
	
	if(!is_notification){
		if(type != email_types.ON_REDEEM)smartags.push({tag:'user_access_link',label:'User access link'});
	}else{
		smartags.push({tag:'user_information',label:'User information'});
	}

	return smartags;
}


export const subject_smartags = (promotion,stages,prizes,email) =>{
	const type = email.type;
	const is_notification = email.notification == 1 ? true : false;
	const has_nickname = promotion.need_nickname ? true : false;
	const has_names = !promotion.hide_name;
	const has_virtual_coins = promotion?.loyalty_enabled ?? false; 
	const more_than_one_stage = stages.length > 1 ? true : false;

	const [has_quiz, has_media_content, has_prizes, has_score, has_redeemable_prizes, has_stamps_card, has_simple_galleries, has_forms] = global_vars(email,promotion,stages,prizes);

	let smartags = [];
	if(has_names){
		//ssif(!has_nickname)smartags.push({tag:'user_full_name',label:'Full name'});
		smartags.push({tag:'user_first_name',label:'User first name'});
		smartags.push({tag:'user_last_name',label:'User last name'});
	}
	if(has_nickname){
		smartags.push({tag:'user_nickname',label:'User nickname'});
	}
	if(type != email_types.ON_REDEEM)smartags.push({tag:'user_email',label:'User email'});

	if(type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE || type == email_types.REJECT_PRIZE || type == email_types.RANKING_LOSE){//Participate
		if(type != email_types.REJECT_PRIZE){
			if(isMultiStage(promotion.promotion_type_id))smartags.push({tag:'stage_name',label:'Stage name'});
			if(has_score){
				smartags.push({tag:'participation_score',label:'Participation Score'});
				//if(more_than_one_stage)smartags.push({tag:'total_score',label:'Total Score'});
			}
		}
			
		if(has_prizes && (type == email_types.PARTICIPATE || type == email_types.WIN_PRIZE || type == email_types.REJECT_PRIZE)){
			let has_prize_codes = false;
			prizes.map((p,i) => {
				if(p.PrizeType.type>0)has_prize_codes=true;
				if(p.PrizeType.reference != undefined){
				}
			})
			smartags.push({tag:'prize_name',label:'Prize Name'});
			if(has_prize_codes && type != email_types.REJECT_PRIZE)smartags.push({tag:'prize_code',label:'Promotional code'});
		}

		if(type == email_types.PARTICIPATE && !is_notification && has_simple_galleries){
			smartags.push({tag:'voted_entry_name',label:'Name of the voted entry'});
		}

	}else if(type == email_types.ACCEPT || type == email_types.REJECT){//Accept or reject
	  //Nothing
	}else{//Manual/Scheduled/Register/OnRedeem/Ontransaction
		if(has_prizes && promotion.login_type == 4 && type == email_types.REGISTER){//Guest Mode + Register => Maybe Prize
			smartags.push({tag:'prize_name',label:'Prize Name'});
		}else if(has_prizes && type == email_types.ON_REDEEM){
		  smartags.push({tag:'prize_name',label:'Prize Name'});
		  if(promotion.code_validator)smartags.push({tag:'validation_site',label:'Validation Point name'});
		}

		if(has_virtual_coins){
			if(type == email_types.ON_TRANSACTION){
				smartags.push({ tag:'transaction_amount', label:"Transaction amount" });
				smartags.push({ tag:'transaction_coin_balance', label:"Coin balance" });
			}else if(type == email_types.NEW_SCHEDULED || type == email_types.MANUAL){
				smartags.push({ tag:'total_coin_balance', label:"Total coin balance" });
			}
		}
	}

	if(has_score && (type == email_types.NEW_SCHEDULED || type == email_types.MANUAL)){
		smartags.push({tag:'total_score',label:'Total Score'});
	}

	return smartags;
}

export const getEmailTypes = (intl, promotion, prizes, stages, display_notifications) => {

	const i18n = (m, c) => i18nIntl(m, intl, c);

	let emailTypes = [];
	const is_guest_mode = promotion.login_type != undefined && promotion.login_type == 4 ? true : false;
	const has_validation_portal = promotion.code_validator  == '1' ? true : false;

	const has_manage_candidates = stages.filter((st) => { return st.Stage.promotion_type_id == stage_promotion_types.MEDIA_CONTEST.id || st.Stage.type == stage_categories.ID_PHOTO_FUN.id}).length > 0;
	if(promotion.login_type == undefined || promotion.login_type != 2) {

		let desc_register = i18n("This email will be automatically sent when a user registers for the first time.");
		if(display_notifications) desc_register = i18n("This notification is sent when a user registers for first time.");
		//Guest Mode or Send to administrator
		emailTypes.push({
			type:email_types.REGISTER,
			mr:'register',
			icon:'knk-mouseover',
			name:i18n("Upon registration"),
			desc:desc_register,
		});
	}

	if(!is_guest_mode) {//GUEST MODE
		let desc_participate = i18n("This email will be automatically sent when a registered user completes participation in a participation stage.");
		if(display_notifications) desc_participate = i18n("This notification is sent when a registered user completes participation in a participation stage.");
		emailTypes.push({
			type:email_types.PARTICIPATE,
			mr:'participate',
			icon:'knk-increase-interactions',
			disabled:(stages.length == 0) ? true : false,
			dis_reason:i18n("You must create a participation stage to use this type of email."),
			name:i18n("Upon participating"),
			desc:desc_participate,
			by_stage:true,
		});


		let desc_winprize = i18n("This email will be automatically sent when a registered user wins a prize.");
		if(display_notifications) desc_winprize = i18n("This notification is sent when a registered user wins a prize.");
		emailTypes.push({
			type:email_types.WIN_PRIZE,
			mr:'winprize',
			icon:'knk-winners',
			//disabled:(prizes.filter(p => {return p.PrizeType.assignation != 2}).length == 0) ? true : false,//No aleatoris
			//dis_reason:i18n("You must create a Manual, On Participate, Instant Win or Probability assignment prize to use this type of email."),
			name:i18n("Upon winning a prize"),
			desc:desc_winprize,
			by_stage:false,
		});

		let desc_rejectprize = i18n("This email will be automatically sent when a user voluntarily rejects a prize, when the prize claiming period expires, or when the administrator replaces a random winner with an alternate.");
		if(display_notifications) desc_rejectprize = i18n("This notification is sent when a user voluntarily rejects a prize, when the prize claiming period expires, or when the administrator replaces a random winner with an alternate.");
		emailTypes.push({
			type:email_types.REJECT_PRIZE,
			mr:'rejectprize',
			icon:'knk-blacklist',
			name:i18n("Upon losing a prize"),
			desc:desc_rejectprize,
			by_stage:false,
		});
	}

	if(!display_notifications && promotion.has_ranking && !isMultiStage(promotion.promotion_type_id) && !is_guest_mode) {
		emailTypes.push({
			type:email_types.RANKING_LOSE,
			mr:'lose-ranking-position',
			icon:'knk-user-loser',
			disabled:(promotion.public_entries == "0" && stages.length > 0) ? true : false,
			dis_reason:i18n("You must enable the ranking of the promotion to use this type of email."),
			name:i18n("Upon losing a specific ranking position"),
			desc:i18n("This email will be automatically sent when a user loses the position number X in the ranking of a game."),
			by_stage:true,
		});
	}
	
	if(!display_notifications && has_manage_candidates) {
		emailTypes.push({
			type:email_types.ACCEPT,
			mr:'accept',
			icon:'knk-accept-user',
			name:i18n("Upon accepting a media entry"),
			desc:i18n("This email will be automatically sent when you accept the content submitted by a user in a multimedia contest with the premoderation enabled."),
			multimedia_content:true,
			by_stage:true,
		});

		emailTypes.push({
			type:email_types.REJECT,
			mr:'reject',
			icon:'knk-reject-user',
			name:i18n("Upon rejecting a media entry"),
			desc:i18n("This email will be automatically sent when you reject the content submitted by a user in a multimedia contest with the premoderation enabled."),
			multimedia_content:true,
			by_stage:true,
		});
	}
	
	if(!display_notifications) {

		emailTypes.push({
			type:email_types.MANUAL,
			mr:'manual',
			icon:'knk-me',
			name:i18n("Manual"),
			desc:i18n("Pick the users you want to contact with and create the email. When ready, confirm and send the email."),
		});
		
		emailTypes.push({
			type:email_types.NEW_SCHEDULED,
			mr:'scheduled',
			icon:'knk-calendar',
			name:i18n("On scheduled date"),
			desc:i18n("This email will automatically be sent on the date and time that you specify."),
			is_scheduled:true,
		});
	}

	if(has_validation_portal || promotion.reward_slider){
		emailTypes.push({
			type:email_types.ON_REDEEM,
			mr:'onredeem',
			icon:'knk-code-redeemed',
			name:i18n("On redeem a prize"),
			desc:i18n("This email will be sent automatically when a user redeems a prize."),
			by_stage:false,
		});
	}

	if(promotion.loyalty_enabled){
		emailTypes.push({
			type:email_types.ON_TRANSACTION,
			mr:'virtualcoins',
			icon:'knk-money',
			name:i18n("Upon completing a virtual coin transaction"),
			desc:i18n("This email will be sent automatically when a user completes a virtual coin transaction."),
			by_stage:false,
		});
	}

	return emailTypes;
}